import React from "react";
import { useStore } from "../store";
import Section from "../components/section/section";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";

export default function EndFrame30() {
  const { section, setSection, showEndFrame } = useStore();
  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 3.0 || !showEndFrame) return null;

  return (
    <Section name="3-0">
      <HexagonButton
        onClick={() => setSection(3.1)}
        disabled={watchedSections.includes(3.1)}
      >
        <div>
          Get to <br />
          the office
        </div>
        <Hexagon1 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(3.2)}
        disabled={watchedSections.includes(3.2)}
      >
        <div>
          Join via <br />
          video conference
        </div>
        <Hexagon2 />
      </HexagonButton>
    </Section>
  );
}
